import { TagTypes } from '../../../Api/Types/tagTypes';
import { UploadContractTemplateLogoCommand } from '../Types/contractTemplatesTypes';
import { contractTemplatesApi } from './contractTemplatesApi';

const extendedContractTemplatesApi = contractTemplatesApi.injectEndpoints({
  endpoints: (builder) => ({
    // Upload logo dla contract template
    uploadContractTemplateLogo: builder.mutation<
      { success: boolean; logoUrl: string },
      UploadContractTemplateLogoCommand
    >({
      query: ({ contractTemplateId, files }) => {
        const formData = new FormData();
        files.forEach((file) => formData.append('files', file));

        return {
          url: `/contract-templates/${contractTemplateId}/upload-logo`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error, { contractTemplateId }) => [
        { type: TagTypes.ContractTemplate, id: contractTemplateId },
        { type: TagTypes.ContractTemplate, id: TagTypes.List },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useUploadContractTemplateLogoMutation } = extendedContractTemplatesApi;
